import { KeyboardEventHandler, ReactNode } from "react";
import styled from "styled-components";

// TEXT

// STYLES
export const Wrapper = styled.div<{
  $fullWidth?: boolean;
}>`
  display: ${({ $fullWidth }) => ($fullWidth ? "flex" : "inline-flex")};
  gap: 0.125rem;
  width: 100%;
  height: 100%;
  flex-direction: column;
`;

// DATA

// TYPES
export type Props = {
  type?: "continuous" | "discrete";
  labels?: ReactNode[];
  fullWidth?: boolean;
  value?: number | number[];
  defaultValue?: number | number[];
  step?: number;
  min?: number;
  max?: number;
  disabled?: boolean;
  onChange?: (value: number | number[], event: Event) => void;
  onChangeCommitted?: (value: number | number[], event: Event) => void;
  onDiscreteKeyDown?: KeyboardEventHandler<HTMLInputElement>;
};

// CONSTANTS

// FUNCTIONS

// ASSETS
